import React from 'react';
import TopTitle from './TopTitle';

function Customer_manage(){

    const thBg = {
        background:'#2F79D9',
        color:'#fff'
    }
    return (
        <>
            <TopTitle title="고객 관리" />
            <div className="container">
                <table className="table table-bordered text-center">
                    <thead>
                        <tr>
                            <th style={thBg}>No</th>
                            <th style={thBg}>고객명</th>
                            <th style={thBg}>차량정보</th>
                            <th style={thBg}>전화번호</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                    <tfoot></tfoot>
                </table>
            </div>
        </>
    )
}

export default Customer_manage;